import { useOfflineSync } from "@/hooks/useOfflineSync";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

import { OfflineStatusIndicator } from "./OfflineStatusIndicator";
import { OfflineSyncButton } from "./OfflineSyncButton";
import { LastSyncInfo } from "./LastSyncInfo";
import { OfflineMessage } from "./OfflineMessage";

export function OfflineStatus() {
  const { isOnline, queueSize, isProcessing, lastSyncTime, processQueue } =
    useOfflineSync();

  if (isOnline && queueSize === 0) {
    return null;
  }

  return (
    <Alert
      className={cn(
        "fixed bottom-4 right-4 z-50 max-w-sm shadow-lg transition-all duration-300",
        "border-2 backdrop-blur-sm",
        {
          "border-emerald-200 bg-emerald-50/90": isOnline,
          "border-amber-200 bg-amber-50/90": !isOnline,
        },
      )}
    >
      <div className="flex items-start gap-3">
        <AlertDescription className="flex-1 space-y-2">
          <div className="space-y-1">
            <OfflineStatusIndicator isOnline={isOnline} queueSize={queueSize} />
            <LastSyncInfo lastSyncTime={lastSyncTime} />
          </div>

          {queueSize > 0 && isOnline && (
            <OfflineSyncButton
              isProcessing={isProcessing}
              onSync={processQueue}
            />
          )}

          <OfflineMessage visible={!isOnline && queueSize > 0} />
        </AlertDescription>
      </div>
    </Alert>
  );
}
